<template>
  <div class="buy-confirm-yuesao">
    <AddressItem
      @click.native="trackClickChangeAddress('CHOOSE_ADDRESS')"
    ></AddressItem>
    <Serve :fillIn="fillIn"></Serve>
    <!-- <Coupon
      @click.native="trackClickChangeAddress('CHOOSE_COUPON')"
      :product="confirmProduct.skuInfo"
    ></Coupon> -->
    <BottomDetail style="margin-bottom: 0.2rem" :fillIn="fillIn"></BottomDetail>
    <PriceDetail
      :isAllPayType="isAllPayType"
      style="margin-bottom: 0.2rem"
    ></PriceDetail>
    <div style="margin-bottom: 0.2rem" v-if="!isAllPayType">
      <pay-period
        :product="confirmProduct"
        :hasUseBlackGoldPrice="confirmProduct.hasUseBlackGoldPrice == 1"
      >
      </pay-period>
    </div>
    <div class="all-pay" v-if="isPayPeriod">
      <span>使用全款购买</span>
      <mt-switch v-model="isAllPay" @change="onChanged"></mt-switch>
    </div>
    <!-- 不要删除-->
    <div class="menu_wkBox_back_box"></div>
    <actions
      :product="confirmProduct"
      :fillIn="fillIn"
      :isAllPayType="isAllPayType"
    ></actions>
    <pageAction
      :viewName="viewName"
      :params="{ ShareCode: shareCode || '' }"
    ></pageAction>
  </div>
</template>

<script>
import { Switch } from 'mint-ui'
import { mapState } from 'vuex'
import Coupon from '@/components/confirmYuesaoValetOrder/coupon'
import Serve from '@/components/confirmYuesaoValetOrder/confirmServe'
import actions from '@/components/confirmYuesaoValetOrder/confirm-action'
import pageAction from '@/components/actionSheet/pageAction'
import AddressItem from '@/components/confirmYuesaoValetOrder/address-item'
import BottomDetail from '@/components/confirmYuesaoValetOrder/bottomDetail'
import PriceDetail from '@/components/confirmYuesaoValetOrder/priceDetail'
import PayPeriod from '../home/components/confirm/pay-period'

import { trackClick, trackView } from './ys_ensure_service_tracker'
import { dispatchMixPromotion } from '@/router/home/new/product.bus'
import { SKUTAGNEED, RULETYPE } from '@/plugins/enum'
import { getValetOrderInfo } from '@/business/confirmOrder'
import { routerEnterTrack } from './sentry_track'
function refreshUrl(keys, url) {
  let search = window.location.search
  search = search.substring(1)
  let newUrl = ''
  let url_arr = []
  if (keys && search !== '') {
    const search_arr = search.split('&')
    const set_search = new Set(search_arr)
    const set_keys = new Set(keys)
    const differenceABSet = new Set(
      [...set_search].filter(x => !set_keys.has(x.split('=')[0]))
    )
    url_arr = Array.from(differenceABSet)
  }
  newUrl = `${window.location.origin + window.location.pathname}${
    url_arr.length > 0 ? `?${url_arr.join('&')}` : ''
  }`
  return newUrl
}
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const u = location.href
      if (u.indexOf('action') > -1) {
        location.replace(refreshUrl(['action', 'viewName']))
      }
      // vm.$store.commit('changeView', 'address')
      vm.$store.commit('hideActionSheet')
    })
  },
  data() {
    return {
      fillIn: {
        serviceDaysReal: 26, //实际服务 天数
        serviceDays: 26, //服务天数
        inviteCode: '', //育儿顾问工号
        inviteName: '', //育儿顾问名称
        remark: '', // 备注
        ycq: '',
        ysCode: '', // 服务人员工号
        ysName: '',
        helpType: 0, //1商客端代客下单
        isSignRenewOrder: 0 //1为续单
      },
      isAllPay: true
    }
  },
  async created() {
    try {
      this.$$title('确认订单')

      /** 重置选择 end */
      const query = this.$route.query
      this.spuId = query.spuId || ''
      this.skuId = query.skuId || ''
      this.address_id = query.address_id || ''
      this.order_time = query.order_time || ''

      const { uid, skey } = await this.$$ensureLogin()
      this.uid = uid
      this.skey = skey
      await this.getProduct()

      this.setData()

      const valetOrder = await getValetOrderInfo()
      if (valetOrder) {
        const {
          serviceDays,
          serviceDaysReal,
          isSignRenewOrder = 0,
          serviceTime: ycq,
          inviteInfo: {
            workerCode: inviteCode = '',
            workerName: inviteName = ''
          },
          workerInfo: { workerCode: ysCode, workerName: ysName },
          helpType
        } = valetOrder
        var { remark } = valetOrder
        let shareCode = ''
        if (valetOrder.shareDetail) {
          shareCode = valetOrder.shareDetail.shareCode || inviteCode
        } else {
          shareCode = inviteCode
        }
        if (helpType == 1 || serviceDaysReal !== serviceDays) {
          remark = `${
            remark ? `${remark},` : ''
          }实际服务天数${serviceDaysReal}天`
        }

        this.fillIn = {
          serviceDays,
          serviceDaysReal,
          inviteCode: /^[wWbB]\d+$/.test(inviteCode) ? shareCode : inviteCode,
          inviteName,
          ycq,
          remark,
          ysCode,
          ysName,
          helpType,
          isSignRenewOrder
        }
      }

      this.getPromotionInfo()

      //获取优惠券
      this.getCouponConfirm()

      this.$$loading(false)
      /*************  获取用户地址 start   ****************/
      const address_id = this.address_id
      if (address_id !== 999999 && uid && skey) {
        // 地址未匹配到 有地址选项
        // 获取用户地址
        const queryAddr = this.$$queryString.stringify({
          uid,
          skey,
          addrtype: 0
        })
        await this.$store.dispatch('getUserAddress', {
          query: queryAddr,
          addrid: address_id
        })
      }

      routerEnterTrack(valetOrder)
      /*************  获取用户地址 end   ****************/
    } catch (e) {
      console.log(e.message)
      console.log(e)
      if (e.message === '1024' || e.message === '4') {
        this.$$login()
      }
    }
  },
  mounted() {
    this.$$allowRefreshOrShare(false, false)
    trackView()
  },
  methods: {
    trackClickChangeAddress(s) {
      trackClick(s)
    },
    onChanged(checked) {
      if (checked) {
        window.scrollTo(0, document.body.scrollHeight)
      }
    },
    setData() {
      const {
        skuInfo: { businessId, spuId, skuId, level4CategoryId }
      } = this.confirmProduct
      this.businessId = businessId
      this.spuId = spuId
      this.skuId = skuId
      this.level4CategoryId = level4CategoryId
    },
    getPromotionInfo() {
      // v21.06.01获取营销活动信息
      dispatchMixPromotion(this)
    },
    async getProduct() {
      try {
        const uid = this.$$cookie('uid')
        const skey = this.$$cookie('skey')
        const query = {
          uid,
          skey,
          skuId: this.skuId,
          channelType: 1
        }
        const shareKeyObj = this.$route.query.hserecomkey || ''
        let shareKey = shareKeyObj
        if (shareKeyObj instanceof Array) {
          const newShareObj = shareKeyObj.filter(v => v)
          if (newShareObj && newShareObj.length > 0) {
            shareKey = newShareObj[newShareObj.length - 1]
          }
        } else if (shareKeyObj === 'undefined') {
          shareKey = ''
        }
        if (shareKey && shareKey !== '') {
          query.shareKey = shareKey
        }
        const queryString = JSON.stringify(query)
        const res = await this.$store.dispatch('getConfirmProduct', queryString)
        if (res.code === '4') {
          this.$$login()
        } else if (res.code !== '1') {
          this.$$toast(res.msg)
        }
      } catch (e) {
        return false
      }
    },
    // TODO 调用旧接口 初始化优惠券  大服务融合需要替换掉
    async getCouponConfirm() {
      const businessId =
        this.confirmProduct.skuInfo && this.confirmProduct.skuInfo.businessId

      // 团购和秒杀没有优惠券
      if (businessId) {
        const json = await this.$store.dispatch('getCoupon4Confirm', {
          uid: this.$$cookie('uid'),
          skey: this.$$cookie('skey'),
          spuId: this.confirmProduct.skuInfo.spuId,
          skuId: this.confirmProduct.skuInfo.skuId,
          sortType: this.confirmProduct.skuInfo.level4CategoryId,
          price: this.confirmProduct.priceInfo.price,
          shopId: businessId || '',
          sourceType:
            this.$$cookie('source') === 'android' ||
            this.$$cookie('source') === 'ios'
              ? 1
              : 2
        })
        if (json.code * 1 === 1) {
          //this.setConfirmCoupons(json.data)
          this.$store.commit('setConfirmCoupons', json.data)
        }
      }
    }
    // checkInfo() {
    //     const addrRight = this.selectedAddress.addrid !== '' && this.selectedAddress.addrid >= 0
    //     const workerRight = this.selectedWorker.code !== '' && this.selectedWorker.uid !== ''
    //     const timeRight = this.selectedTime !== ''
    //     const address_id = this.selectedAddress.addrid
    //     const staff_id = this.selectedWorker.code
    //     const order_time = this.selectedTime
    //     this.getProduct(address_id, this.prid, staff_id, order_time)
    // }
  },
  computed: {
    ...mapState([
      'confirmProduct',
      'workers',
      'viewName',
      'selectedWorker',
      'selectedAddress',
      'selectedTime'
    ]),
    shareCode() {
      const code =
        this.confirmProduct.shareDetail &&
        this.confirmProduct.shareDetail.shareCode
      return code
    },
    skuTag() {
      return (
        this.confirmProduct &&
        this.confirmProduct.skuInfo &&
        this.confirmProduct.skuInfo.skuTag
      )
    },
    //是否支持定金支付
    isPayPeriod() {
      return (
        this.confirmProduct &&
        this.confirmProduct.skuInfo &&
        this.confirmProduct.skuInfo.supportPayment &&
        this.confirmProduct.skuInfo.supportPayment == 1
      )
    },
    //是否旧的付款方式：付全款
    isAllPayType() {
      return this.isAllPay || !this.isPayPeriod
    }
  },
  components: {
    Coupon,
    Serve,
    actions,
    pageAction,
    'mt-switch': Switch,
    AddressItem,
    BottomDetail,
    PriceDetail,
    PayPeriod
  }
}
</script>

<style lang="scss">
@import '../../assets/css/mixin';
.buy-confirm-yuesao .mint-switch-input:checked + .mint-switch-core {
  border-color: #ff5900;
  background-color: #ff5900;
}

.buy-confirm-yuesao {
  min-height: 100vh;
  padding: 0 rem(24px);
  padding-top: rem(21px);
  padding-bottom: rem(119px);
}
</style>
<style lang="scss">
@import '../../assets/css/mixin';

.buy-confirm-yuesao {
  .label-ui {
    font-size: rem(26px);
    color: #262626;
    flex: none;
  }
  .item-layout {
    padding: 0 rem(24px);
  }
  .item-common-layout {
    width: 100%;
    padding: 0;
    min-height: rem(99px);
    @include border(bottom, #f2f2f2, 1px);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .item-common-content {
    width: 100%;
    flex-direction: column;
    overflow: hidden;
    .block {
      display: flex;
      .label-ui {
        flex: none;
        width: rem(160px);
        display: flex;
        align-items: center;
      }
      .item-cell-bd {
        flex: auto;
        font-size: rem(28px);
        .default {
          color: #999;
        }
      }
    }
  }
  .item-common {
    min-height: rem(76px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 rem(24px);
  }
  .icon-arr-r {
    flex: none;
    display: inline-block;
    width: rem(44px);
    height: rem(32px);
    background: url('~@/assets/images/icon-arr-r@3x.png') no-repeat center right;
    background-size: auto rem(20px);
  }
  .item-cells {
    font-size: rem(26px);
  }
  .all-pay {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: rem(20px);
    padding: 0 rem(24px);
    background-color: #fff;
    border-radius: rem(16px);
    height: rem(96px);
    span {
      font-size: rem(26px);
      color: #262626;
    }
  }
}
</style>
